/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamChatMessage
 */
export interface TeamChatMessage {
    /**
     * 
     * @type {string}
     * @memberof TeamChatMessage
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TeamChatMessage
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof TeamChatMessage
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof TeamChatMessage
     */
    message: string;
}

/**
 * Check if a given object implements the TeamChatMessage interface.
 */
export function instanceOfTeamChatMessage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function TeamChatMessageFromJSON(json: any): TeamChatMessage {
    return TeamChatMessageFromJSONTyped(json, false);
}

export function TeamChatMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamChatMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'userId': json['userId'],
        'message': json['message'],
    };
}

export function TeamChatMessageToJSON(value?: TeamChatMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': (value.date.toISOString()),
        'userId': value.userId,
        'message': value.message,
    };
}

